import "@/App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Checkout from "@/pages/Checkout";
import Confirmation from "@/pages/Confirmation";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import Legal from "@/pages/Legal";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Toaster position="top-center" richColors />
                <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/checkout" element={<Checkout />} />
                    <Route path="/confirmation/:orderId" element={<Confirmation />} />
                    <Route path="/terms" element={<Legal doc="terms" />} />
                    <Route path="/refund-policy" element={<Legal doc="refund" />} />
                    <Route path="/privacy" element={<Legal doc="privacy" />} />
                    <Route path="/itf-control-panel" element={<AdminLogin />} />
                    <Route path="/itf-control-panel/dashboard" element={<AdminDashboard />} />
                    <Route path="*" element={<Landing />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
